import React, { useContext, useEffect } from "react";
import { Upload, message } from "antd";
import ImgCrop from "antd-img-crop";
import { context } from "./../../context/context";
import config from "../../services/config.json";

const TravelUploadMedia = () => {
    // context
    const {
        travelMedia,
        setTravelMedia,
        travelCover,
        setTravelCover,
        setTravelCoverId,
        travelMediaId,
        setTravelMediaId,
        travelCoverId,
    } = useContext(context);
    // useEffect
    useEffect(() => {
        setTravelCoverId(travelCover[0] ? travelCover[0]._id : null);
        const ids = [];
        const files = [];
        travelMedia.map((file) => {
            ids.push(file._id);
            files.push({
                uid: file._id,
                name: `${file.type}/${file._id}`,
                status: "done",
                url: file.address,
            });
        });
        setTravelMediaId(ids);
        setTravelMedia(files);
        setTravelCover([
            {
                uid: travelCoverId,
                name: "image.png",
                status: "done",
                url: travelCover[0]?.address,
            },
        ]);
    }, []);
    // upload
    const onChangeCover = (info) => {
        setTravelCover(info.fileList);
        if (info.file.status === "done") {
            message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
            setTravelCoverId(info.file.response.files[0]._id);
        } else if (info.file.status === "error") {
            message.error(` در آپلود فایل خطایی رخ داد!`);
        }
    };
    const onChange = (info) => {
        setTravelMedia(info.fileList);
        if (info.file.status === "done") {
            message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
            info.file.response.files.map((file) => {
                setTravelMediaId([...travelMediaId, file._id]);
            });
        } else if (info.file.status === "error") {
            message.error(` در آپلود فایل خطایی رخ داد!`);
        }
    };
    const onPreview = async (file) => {
        console.log(file);
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };
    const handleRemove = (info) => {
        const newFiles = travelMedia.filter((file) => file !== info);
        const newIds = travelMediaId.filter((id) => id !== info.uid);
        setTravelMediaId(newIds);
        setTravelMedia(newFiles);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                padding: "2rem 0",
                gap: "2rem",
            }}
        >
            <ImgCrop modalTitle="ویرایش عکس" aspect={2} rotationSlider>
                <Upload
                    maxCount={1}
                    multiple={false}
                    name="objectKey"
                    action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65dee681da848985cf622143`}
                    listType="picture-card"
                    fileList={travelCover}
                    onChange={onChangeCover}
                    onPreview={onPreview}
                >
                    {travelCover.length < 5 && "+ آپلود عکس کاور"}
                </Upload>
            </ImgCrop>
            <ImgCrop modalTitle="ویرایش عکس" rotationSlider>
                <Upload
                    accept="image/*"
                    multiple={false}
                    name="objectKey"
                    action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65dee68eda848985cf622150`}
                    listType="picture-card"
                    fileList={travelMedia}
                    onChange={onChange}
                    onPreview={onPreview}
                    onRemove={handleRemove}
                >
                    {travelCover.length < 3 && "+ آپلود عکس"}
                </Upload>
            </ImgCrop>
            <Upload
                accept="video/*"
                multiple={false}
                name="objectKey"
                action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65dee68eda848985cf622150`}
                listType="picture-card"
                fileList={travelMedia}
                onChange={onChange}
                onPreview={onPreview}
                onRemove={handleRemove}
            >
                {travelCover.length < 3 && "+ آپلود ویدیو"}
            </Upload>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    flexWrap: "wrap",
                    gap: "2rem",
                }}
            >
                {travelMedia.map((media) => {
                    if (media.name && media.name.slice(0, 5) === "video") {
                        return (
                            <video
                                src={media.url}
                                controls
                                style={{ width: "20rem" }}
                            ></video>
                        );
                    } else if (
                        media.type &&
                        media.type.slice(0, 5) === "video"
                    ) {
                        return (
                            <video
                                src={media.response?.files[0].address}
                                controls
                                style={{ width: "20rem" }}
                            ></video>
                        );
                    }
                })}
            </div>
        </div>
    );
};

export default TravelUploadMedia;
